// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class hero {
	constructor () {
		this.$hero                = $('.hero')
		this.$whiteBox            = $('.white-box')
		this.videoPlayButton      = $('.video-play-button-container')
		this.$videoEmbedContainer = $('.video-embed-container')

		this.videoPlayButton.click((event) => {
			this.vimeoIframe = $('.hero iframe')[0]
			this.vimeoPlayer = new Vimeo.Player(this.vimeoIframe)
			this.vimeoPlayer.play()

			this.videoPlayButton.addClass('invisible')
			this.$videoEmbedContainer.removeClass('invisible')
		})
	}

	onWindowLoad () {
		this.$hero.removeClass('before-load')

		setTimeout(() => {
			this.$whiteBox.removeClass('before-load')
		}, 400)
	}
}

export default hero


// WEBPACK FOOTER //
// ./src/js/triboro/hero/hero.js